import type { CheckoutConfig } from '#types/config/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  allowSplitPayments: {
    EMEA: false,
    NORA: true
  }
} satisfies RecursivePartial<CheckoutConfig['payments']>
